<template>
  <!-- 关键：外层 div 直接用保存的高度撑开 -->
  <div class="page-restore" :style="{ minHeight: savedHeight + 'px' }">
    <div ref="content" class="content">
      <div>
        <nav class="navbar navbar-expand-lg navbar-light bg-dark">
          <a
            class="navbar-brand"
            style="color: white"
            href="http://xinyuntongji.com"
            target="_blank"
            >新云统计 官网：www.xinyuntongji.com</a
          >

          <div
            class="collapse navbar-collapse"
            id="navbarSupportedContent"
          ></div>
        </nav>
        <div
          class="jumbotron"
          style="
            margin-left: 7%;
            margin-top: 1%;
            margin-bottom: 0;
            width: 85%;
            padding-top: 1%;
            padding-bottom: 0.5%;
          "
        >
          <p class="h6">
            当前正在查看分组：<label
              class="btn btn-info active group"
              style="pointer-events: none"
              disabled=""
              id="group_id"
              >{{ form.group }}</label
            >
          </p>
          <p class="h6">
            当前全部过滤状态：<label
              v-if="form.filterState"
              class="btn btn-warning active"
              style="pointer-events: none; color: #fff"
              disabled=""
              >已开启，注意--测试时请关闭全局过滤 (开启全局过滤:
              同一个账号添加软件里的所有账号，只统计一个申请)</label
            ><label
              v-else
              class="btn btn-info active"
              style="pointer-events: none; color: #fff"
              disabled=""
              >未开启</label
            >
          </p>
          <p class="h6">
            最后刷新时间：<label
              class="btn btn-info active"
              style="pointer-events: none"
              disabled=""
              id="time_label_id"
              >{{ getTime() }} </label
            >&nbsp;<label
              class="btn btn-info active"
              style="
                pointer-events: none;
                color: red;
                background: none;
                border: none;
              "
              disabled
            >
              注：申请数据20秒自动刷新一次，加过好友的，互删再重新添加也不会统计(可联系客服清空数据库)</label
            >
          </p>
          <hr class="my-2" />
          <p style="margin-bottom: 0">
            提示： 购买与使用问题,
            <a href="#" @click="openDialog">请点击添加客服微信</a>
          </p>
          <hr class="my-2" />
          <p>
            <span
              style="
                color: dodgerblue;
                margin-top: 1%;
                margin-bottom: 0;
                font-size: large;
              "
              >免责声明：</span
            ><span style="color: red; margin-top: 1%; margin-bottom: 0"
              >本软件只是广告/营销效果统计工具，只读取官方公开数据，没有任何非法功能！我们只服务正规企业，使用者必须遵守相关法律法规，违法行为一经发现将立即封号且不退费，谢谢！</span
            >
          </p>
        </div>
        <div style="margin-left: 7%; margin-top: 1%; width: 85%">
          <div class="card-deck">
            <div class="card bg-warning mb-3" style="max-width: 18rem">
              <div class="card-body">
                <h5
                  class="card-title"
                  id="accounts_label_id"
                  style="color: #212529"
                >
                  {{ totolAccount }}
                </h5>
                <p class="card-text" style="color: #212529">账号总数量</p>
              </div>
            </div>

            <div class="card bg-info mb-3" style="max-width: 18rem">
              <div class="card-body">
                <h5
                  class="card-title"
                  id="apply_label_id"
                  style="color: #212529"
                >
                  {{ form.accounts.length != 0 ? applyNum : "" }}
                </h5>
                <p class="card-text" style="color: #212529">申请总数量</p>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-left: 7%; width: 85%">
          <button
            type="button"
            class="btn btn-primary"
            style="margin-bottom: 1rem"
            @click="downloadAllQrcodes"
          >
            一键下载所有二维码
          </button>

          <table class="table">
            <thead class="thead-light">
              <tr>
                <th scope="col">序号</th>
                <th scope="col">头像</th>
                <th scope="col">昵称</th>
                <th scope="col">主体</th>
                <th scope="col">二维码</th>
                <th scope="col">状态</th>
                <th scope="col">申请</th>
                <th scope="col">最新重复粉</th>
                <th scope="col">备注</th>
                <th scope="col">最后申请时间</th>
                <th scope="col">最后登录时间</th>
              </tr>
            </thead>
            <tbody v-if="tableList && tableList.length == 0">
              <tr>
                <td :colspan="colNum">
                  暂无数据或数据错误，请检查链接后再重试
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr
                v-for="(account, index) in tableList"
                :key="account.vid || account.nickName + index"
              >
                <th scope="row">{{ index + 1 }}</th>
                <th>
                  <img
                    :src="account.avatar || '/default-avatar.png'"
                    alt="avatar"
                    style="width: 40px; height: 40px"
                  />
                </th>
                <th>{{ account.nickName }}</th>
                <th class="text-success">{{ account.corpName }}</th>
                <th>
                  <a
                    href="javascript:void(0)"
                    @click="form.qrcodeShow && preview(account)"
                    :style="{
                      pointerEvents: form.qrcodeShow ? 'auto' : 'none',
                    }"
                  >
                    {{ form.qrcodeShow ? "点击获取二维码" : "*****" }}
                  </a>
                </th>
                <th :class="account.login ? 'text-success' : 'text-danger'">
                  {{ account.login ? "在线" : "离线" }}
                </th>
                <th>{{ account.applyCount || 0 }}</th>
                <th>{{ account.lastDuplicateApplyNickname || "" }}</th>
                <th>{{ account.remark || "" }}</th>
                <th>{{ account.lastApplyTime || "" }}</th>
                <th>{{ account.lastLogingTime || "" }}</th>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="modal fade in"
          id="wechatModal"
          tabindex="-1"
          style="display: none"
        >
          <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h6 class="modal-title">客服微信</h6>
                <button
                  type="button"
                  class="dialog-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="closeDialog"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <p></p>
                <img
                  :src="require('@/assets/wechat_qr_code.png')"
                  width="250"
                  height="250"
                  alt="客服微信二维码"
                  style="
                    display: block !important;
                    text-align: center;
                    margin: auto;
                  "
                />

                <p></p>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeDialog"
                >
                  关闭
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SharePage",
  data() {
    return {
      totolAccount: 0,
      applyNum: 0,
      showDialog: false,
      form: {
        filterState: false,
        group: "",
        lastDateTime: "",
        accounts: [],
        total_apply_count: 0,
        ads: {},
        qrcodeShow: false,
      },
      tableList: [],
      timer: null,
      savedHeight: 1000, // 默认值，防止闪白
      savedScroll: 0,
      colNum: 3,
    };
  },
  created() {
    // 1. 页面加载瞬间读取上次保存的状态（最快！）
    const state = sessionStorage.getItem("PAGE_RESTORE_STATE");
    if (state) {
      const { h, s } = JSON.parse(state);
      this.savedHeight = h;
      this.savedScroll = s;
    }
    // 2. 读取缓存的表格数据，提升用户体验
    const cachedData = sessionStorage.getItem("TABLE_DATA_CACHE");
    if (cachedData) {
      const { tableList, form, applyNum, totolAccount } =
        JSON.parse(cachedData);
      this.tableList = tableList;
      this.form = form;
      this.applyNum = applyNum;
      this.totolAccount = totolAccount;
    }
    let param = this.$route.params.pathMatch;
    if (param) {
      let pa = param.slice(0, -10) + this.getUnixTimestamp();
      this.getList(pa);
    } else {
      const initData = this.$options.data.call(this);
      this.tableList = initData.tableList;
      this.applyNum = initData.applyNum;
      this.totolAccount = initData.totolAccount;
      this.form = initData.form;
    }
  },
  mounted() {
    // 1. 开启定时器
    this.timer = setInterval(() => {
      this.refreshTime();
    }, 20000);
    // 2. DOM 出现后立刻设置滚动位置（因为高度已经撑好了，不会闪）
    if (this.savedScroll > 0) {
      this.$refs.content.scrollTop = this.savedScroll;
      // 或者如果是 window 滚动：window.scrollTo(0, this.savedScroll)
    }

    // 3. 实时保存（内容变化时更新高度）
    const save = () => {
      sessionStorage.setItem(
        "PAGE_RESTORE_STATE",
        JSON.stringify({
          h: this.$refs.content.scrollHeight,
          s: this.$refs.content.scrollTop || window.pageYOffset,
        })
      );
    };

    const debounced = this.debounce(save, 300);
    window.addEventListener("scroll", debounced, true);
    window.addEventListener("beforeunload", save);
  },
  methods: {
    getUnixTimestamp() {
      return Math.floor(Date.now() / 1000);
    },
    debounce(fn, wait) {
      let t;
      return () => {
        clearTimeout(t);
        t = setTimeout(fn, wait);
      };
    },
    handleScroll() {
      clearTimeout(this._st);
      this._st = setTimeout(() => {
        const y = window.pageYOffset || document.documentElement.scrollTop;
        sessionStorage.setItem("MY_LIST_SCROLL", y);
      }, 150);
    },

    saveScrollPosition() {
      const y = window.pageYOffset || document.documentElement.scrollTop;
      sessionStorage.setItem("MY_LIST_SCROLL", y);
    },
    refreshTime() {
      this.colNum = 10;
      let param = this.$route.params.pathMatch;
      if (param) {
        let pa = param.slice(0, -10) + this.getUnixTimestamp();
        this.getList(pa);
        // 更新缓存
        sessionStorage.setItem(
          "TABLE_DATA_CACHE",
          JSON.stringify({
            tableList: this.tableList,
            form: this.form,
            applyNum: this.applyNum,
            totolAccount: this.totolAccount,
          })
        );
      } else {
        const initData = this.$options.data.call(this);
        this.tableList = initData.tableList;
        this.applyNum = initData.applyNum;
        this.totolAccount = initData.totolAccount;
        this.form = initData.form;
      }
    },
    async getList(param1) {
      if (param1) {
        let param = {
          param: param1,
        };
        await this.$axios({
          method: "post",
          url: "/api/result/apply",
          params: param,
        })
          .then((res) => {
            if (res.data.code === 200) {
              const res1 = res.data.data
              this.tableList = res1.accounts;
              this.form = res1
              this.applyNum = this.form.total_apply_count;
              this.totolAccount = this.form.accounts.length;
              // 保存最新数据到缓存
              sessionStorage.setItem(
                "TABLE_DATA_CACHE",
                JSON.stringify({
                  tableList: this.tableList,
                  form: this.form,
                  applyNum: this.applyNum,
                  totolAccount: this.totolAccount,
                })
              );
              // 数据请求完、DOM 更新完后立刻恢复滚动（最智能！）
              this.$nextTick(() => {
                // 再加一层 nextTick，确保 v-for 完全渲染完
                this.$nextTick(() => {
                  const savedY = sessionStorage.getItem("MY_LIST_SCROLL");
                  if (savedY && Number(savedY) > 0) {
                    // 如果你用的是 div 滚动，改成下面这行：
                    // document.querySelector('.page-content')?.scrollTop = Number(savedY)

                    window.scrollTo(0, Number(savedY));
                  }
                });
              });
            }
          })
          .catch(() => {
            console.log("请求错误，恢复初始数据");
            const initData = this.$options.data.call(this);
            this.tableList = initData.tableList;
            this.applyNum = initData.applyNum;
            this.totolAccount = initData.totolAccount;
            this.form = initData.form;
            sessionStorage.setItem(
              "TABLE_DATA_CACHE",
              JSON.stringify({
                tableList: this.tableList,
                form: this.form,
                applyNum: this.applyNum,
                totolAccount: this.totolAccount,
              })
            );
          });
      } else {
        const initData = this.$options.data.call(this);
        this.tableList = initData.tableList;
        this.applyNum = initData.applyNum;
        this.totolAccount = initData.totolAccount;
        this.form = initData.form;
        sessionStorage.setItem(
          "TABLE_DATA_CACHE",
          JSON.stringify({
            tableList: this.tableList,
            form: this.form,
            applyNum: this.applyNum,
            totolAccount: this.totolAccount,
          })
        );
      }
    },
    downloadAllQrcodes() {
      let param = {
        vids: "",
      };
      this.$axios({
        method: "post",
        url: "/api/result/download",
        params: param, // POST 请求用 data，不是 params！
        responseType: "blob", // 关键！告诉 axios 返回的是二进制文件
      })
        .then((response) => {
          // 1. 从响应头里尝试拿到文件名（推荐后端配合返回）
          const contentDisposition = response.headers["content-disposition"];
          let fileName = "二维码.zip";
          if (contentDisposition) {
            const match = contentDisposition.match(/filename\*?=UTF-8''(.+)/);
            if (match && match[1]) {
              fileName = decodeURIComponent(match[1]);
            }
          }

          // 2. 创建 blob 并触发下载
          const blob = new Blob([response.data], { type: "application/zip" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(url); // 释放内存
        })
        .catch((err) => {
          console.error("下载失败", err);
        });
    },
    getTime() {
      return this.form.lastDateTime.replace("T", " ").split(".")[0];
    },
    openDialog() {
      let modal = document.getElementById("wechatModal");
      modal.classList.add("show");
      modal.style.display = "block";
      modal.setAttribute("aria-modal", "true");
      modal.setAttribute("role", "dialog");
    },
    closeDialog() {
      let modals = document.getElementsByClassName("modal fade in");
      for (let i = 0; i < modals.length; i++) {
        modals[i].classList.remove("show");
        modals[i].style.display = "none";
        modals[i].removeAttribute("aria-modal");
        modals[i].removeAttribute("role");
      }
    },
    qrcodeShow() {},
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("beforeunload", this.saveScrollPosition);
    // 保存最终数据到缓存
    sessionStorage.setItem(
      "TABLE_DATA_CACHE",
      JSON.stringify({
        tableList: this.tableList,
        form: this.form,
        applyNum: this.applyNum,
        totolAccount: this.totolAccount,
      })
    );
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
